import { useState, type FormEvent } from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (q) navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <section className="relative flex min-h-[560px] items-center overflow-hidden bg-background-950">
      <img
        src="https://readdy.ai/api/search-image?query=panoramic%20anime%20manga%20scene%20collage%20of%20colorful%20hero%20silhouettes%20and%20floating%20comic%20panels%2C%20warm%20orange%20vermillion%20and%20amber%20with%20teal%20accents%2C%20energetic%20stylized%20illustration%2C%20dark%20cinematic%20background%20with%20soft%20glows%2C%20high%20detail&width=1800&height=1000&seq=manga-hero-2026&orientation=landscape"
        alt="4399漫画网精选漫画世界"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/80"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-secondary-400"></i>
          每日更新 · 万千漫画等你来追
        </span>
        <h1 className="mx-auto mt-6 max-w-3xl font-display text-4xl leading-tight text-background-50 md:text-6xl">
          4399漫画网
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
          热门排行、新上架作品、完结作品库一站尽览。按分类浏览全部漫画，站内搜索快速定位，让追漫更高效。
        </p>

        <form onSubmit={handleSearch} className="mx-auto mt-8 flex w-full max-w-xl items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 p-2 backdrop-blur">
          <i className="ri-search-line pl-3 text-lg text-background-100"></i>
          <input
            type="search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="输入漫画名称，比如：星穹破晓"
            aria-label="搜索漫画"
            className="flex-1 bg-transparent text-sm text-background-50 outline-none placeholder:text-background-100/60 md:text-base"
          />
          <button type="submit" className="rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-400 whitespace-nowrap">
            搜索漫画
          </button>
        </form>

        <div className="mx-auto mt-10 grid w-full max-w-2xl grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { num: '3600+', label: '部收录漫画' },
            { num: '8', label: '大热门分类' },
            { num: '12万+', label: '话在线章节' },
            { num: '24h', label: '全天候更新' },
          ].map((s) => (
            <div key={s.label} className="rounded-lg border border-background-50/15 bg-background-50/5 px-3 py-4 backdrop-blur">
              <p className="font-display text-2xl text-secondary-300">{s.num}</p>
              <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/comics" className="rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-400 whitespace-nowrap">
            浏览全部漫画
          </Link>
          <Link to="/comics?sort=hot" className="rounded-full border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 hover:bg-background-50/20 whitespace-nowrap">
            查看热门排行
          </Link>
        </div>
      </div>
    </section>
  );
}